// extracted by mini-css-extract-plugin
export default {"container":"DaysWithMissedIncome_container_D74mW"};